import {
    ConditionComparisonOpList,
    ConditionModel,
    ConditionParameter,
    ConditionParameterList
} from "@/views/loyalty/models/condtion.model"

class Condition_class {
    constructor (data) {
        this.condition = data || ConditionModel
        this.conditionParameterList = []
    }

    conditionParameters (conditionParameterList) {
        this.conditionParameterList = conditionParameterList
        return this
    }

    get comparisonOpHuman () {
        const comparisonOpHumanObj = ConditionComparisonOpList.find(f => f.value === this.condition.comparisonOp)
        const text = comparisonOpHumanObj ? comparisonOpHumanObj.text : ''
        return { comparisonOpHuman: text }
    }

    get item () {
        return Object.assign(this.condition, this.comparisonOpHuman, this.parameterHuman)
    }

    get parameterHuman () {
        const conditionParameter = this.conditionParameterList.find(f => f.value === this.condition.parameter) || ConditionParameter
        console.log('conditionParameter', conditionParameter)
        return { parameterHuman: conditionParameter.text }
    }

    static clearItems () {
        return {
            ruleId: 0,
            conditionId: 0,
            parameter: "",
            comparisonOp: "",
            value: [],
            // binaryOp: "",
        }
    }
}

export default Condition_class
